import { render, staticRenderFns } from "./CopyToReportingPreferences.vue?vue&type=template&id=76ce0ebe&scoped=true"
import script from "./CopyToReportingPreferences.vue?vue&type=script&lang=js"
export * from "./CopyToReportingPreferences.vue?vue&type=script&lang=js"
import style0 from "./CopyToReportingPreferences.vue?vue&type=style&index=0&id=76ce0ebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce0ebe",
  null
  
)

export default component.exports